import React from 'react';
import { connect } from 'react-redux';

import EditableTitle from './EditableTitle';

import { renameStory } from "../../data/stories/StoryActions";

const mapDispatchToProps = (dispatch, ownProps) => ({
    onBlur: name => dispatch(renameStory(ownProps.storyId, name))
});

export default connect(
    null,
    mapDispatchToProps
)(EditableTitle);
